import React from 'react';
import { CheckIcon, LaptopIcon, SmartphoneIcon, TabletIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { FOR_WHO, FOR_WHO_THOUGHTS } from '../../data/content';
const DEVICES = [{
  label: 'Celular',
  Icon: SmartphoneIcon
}, {
  label: 'Computadora',
  Icon: LaptopIcon
}, {
  label: 'Tablet',
  Icon: TabletIcon
}];
export function ForWho() {
  return;
}